import { SUPPORTING_SKILL_WEIGHT } from "PFTypes";

import { useSkillsOfWeight } from "./use_skills_of_weight";

export const useSupportingSkills = () => {
  const { roleSkills, matchSkills, missingMatchSkills } = useSkillsOfWeight(SUPPORTING_SKILL_WEIGHT);

  return {
    roleSupportingSkills: roleSkills,
    matchSupportingSkills: matchSkills,
    missingMatchSupportingSkills: missingMatchSkills
  };
};
